import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SoftBanGuard } from 'src/app/shared/guards/soft-ban.guard';
import { UserGuard } from '../../shared/guards/user.guard';
import { CarerBookedJobPage } from './pages/jobs/booked/carer/carer.page';
import { ConsumerBookedJobPage } from './pages/jobs/booked/consumer/consumer.page';
import { FlexJobInfoComponent } from './pages/jobs/create/flex-job-info/flex-job-info.component';
import { FlexJobFormPage } from './pages/jobs/create/form/form.page';
import { CarerOpenJobPage } from './pages/jobs/open/carer/carer.page';
import { ConsumerOpenJobPage } from './pages/jobs/open/consumer/consumer.page';

const routes: Routes = [
  {
    path: 'jobs',
    data: { title: 'View Flex Jobs' },
    canActivate: [UserGuard],
    children: [
      {
        path: 'create',
        data: { title: 'Create Flex Job' },
        canActivate: [UserGuard, SoftBanGuard],
        children: [
          {
            path: 'form',
            component: FlexJobFormPage,
            data: { title: 'Create Flex Job' },
            canActivate: [UserGuard, SoftBanGuard],
          },
          {
            path: 'info',
            component: FlexJobInfoComponent,
            data: { title: 'View Flex Job Info' },
            canActivate: [UserGuard, SoftBanGuard],
          },
        ],
      },
      {
        path: 'open',
        data: { title: 'View Flex Open Job' },
        canActivate: [UserGuard],
        children: [
          {
            path: 'carer',
            data: { title: 'View Carer Flex Open Job' },
            canActivate: [UserGuard],
            children: [
              {
                path: ':id',
                component: CarerOpenJobPage,
              },
            ],
          },
          {
            path: 'consumer',
            data: { title: 'View Consumer Flex Open Job' },
            canActivate: [UserGuard],
            children: [
              {
                path: ':id',
                component: ConsumerOpenJobPage,
              },
            ],
          },
        ],
      },
      {
        path: 'booked/consumer',
        data: { title: 'View Flex Booked Job' },
        canActivate: [UserGuard],
        children: [
          {
            path: ':id',
            component: ConsumerBookedJobPage,
            data: { title: 'View Comsumer Flex Booked Job' },
            canActivate: [UserGuard],
          },
        ],
      },
      {
        path: 'booked/carer',
        data: { title: 'View Flex Booked Job' },
        canActivate: [UserGuard],
        children: [
          {
            path: ':id',
            component: CarerBookedJobPage,
            data: { title: 'View Carer Flex Booked Job' },
            canActivate: [UserGuard],
          },
        ],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlexRoutingModule {}
